import React from "react";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background text-on-background">
      {children}
    </div>
  );
};

export default Layout;
